import { render, staticRenderFns } from "./PackageOrderInfo.vue?vue&type=template&id=5201f2f6&scoped=true&"
import script from "./PackageOrderInfo.vue?vue&type=script&lang=js&"
export * from "./PackageOrderInfo.vue?vue&type=script&lang=js&"
import style0 from "./PackageOrderInfo.vue?vue&type=style&index=0&id=5201f2f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5201f2f6",
  null
  
)

export default component.exports